export default (field, fields) => {
  return fields[field];
};
